
        <span>
            <ng-container *ngFor="let detail of details; let last = last">
                <a href="javascript:void(0)" (click)="openContainerSearchDialogFunk(detail.containerNumber)">
                    {{ detail.containerNumber }}
                </a>
                <span *ngIf="!last">, </span>
            </ng-container>
        </span>
    